import { render, staticRenderFns } from "./ProductItem3.vue?vue&type=template&id=5aab5f15&"
import script from "./ProductItem3.vue?vue&type=script&lang=js&"
export * from "./ProductItem3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports